<template>
    <section>
        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <el-form :inline="true" :model="formInline" class="demo-form-inline" align="left" style="text-align: left">
                <el-form-item>
                    <el-input v-model="formInline.Keyword" placeholder="Country" @keyup.enter.native=''></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" style="width: 120px" icon="el-icon-search" @click.native.prevent="queryArea">查找</el-button>
                </el-form-item>
                <el-form-item>
                    <el-popover
                            placement="bottom"
                            width="400"
                            trigger="click">
                        <el-table :data="gridData">
                            <el-table-column width="50" property="area" label="区域"></el-table-column>
                            <el-table-column width="320" property="countries" label="国家"></el-table-column>
                        </el-table>
                        <el-button icon="el-icon-document" slot="reference" style="width: 120px">可支持国家</el-button>
                    </el-popover>
                </el-form-item>
                <el-form-item>
                    <el-button icon="el-icon-edit" style="width: 120px" @click.native.prevent="showAddDialog">添加国家</el-button>
                </el-form-item>
            </el-form>
        </el-col>
        <!--列表-->
        <template>
            <el-table :data="areaData" highlight-current-row  style="width: 100%;" stripe @row-click="editArea">
                <el-table-column prop="Country" label="Country" width="130" sortable></el-table-column>
                <el-table-column prop="ClientType" label="ClientType" width="220" ></el-table-column>
                <el-table-column prop="AvsStatus" label="Alexa Buildin" width="120" ></el-table-column>
                <el-table-column prop="WwaStatus" label="Work with Alexa" width="120" ></el-table-column>
                <el-table-column prop="ShsMode" label="Smarthome skill mode" width="180" ></el-table-column>
                <el-table-column prop="Action" label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button @click="editArea(scope.row)" v-show="seen()" type="primary" size="mini" style="width: auto" icon="el-icon-edit"></el-button>
                        <el-button @click="deleteArea(scope.row)" v-show="seen()" type="danger" size="mini" icon="el-icon-delete" style="width: auto"></el-button>
                    </template>
                </el-table-column>
            </el-table>
        </template>
        <!--分页-->
        <el-col :span="24" class="toolbar" style="padding-bottom:10px;">
            <el-pagination :current-page="pageIndex" :page-sizes="pageSizes" :page-size="pageSize"
                           layout="total, sizes, prev, pager, next, jumper" :total="totaltotal"
                           v-on:current-change="pageIndexChange" v-on:size-change="sizeChange" ><!-- style="float:none" -->
            </el-pagination>
        </el-col>
        <!--编辑界面-->
        <el-dialog width='500px' :title="editFormTitle" v-model="editFormVisible" :visible.sync="editFormVisible" :close-on-click-modal="false">
            <el-form :model="areaForm" label-width="130px" ref="areaForm" :rules="areaFormRules">
                <el-form-item label="Country:" prop="Country">
                    <el-input class="dialog_input" v-model="areaForm.Country" :disabled="editType!==0"></el-input>
                </el-form-item>
                <el-form-item label="Domain:" prop="Domain">
                    <el-select v-model="areaForm.Domain" placeholder="请选择" style="width:87%;">
                        <el-option v-for="item in supportDomains" :key="item.Id" :label="item.Name" :value="item.Id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="ClientType:" prop="ClientType">
                    <el-input class="dialog_input" v-model="areaForm.ClientType" :disabled="editType!==0"></el-input>
                </el-form-item>
                <el-form-item label="Alexa Buildin:" prop="AvsStatus">
                    <!--el-select v-model="areaForm.AvsStatus" placeholder="请选择" style="width:87%;">
                        <el-option v-for="item in alexaStatus" :key="item.Id" :label="item.Name" :value="item.Name">
                        </el-option>
                    </el-select-->
                    <el-radio-group v-model="areaForm.AvsStatus" >
                        <el-radio label="enable"></el-radio>
                        <el-radio label="disable"></el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="Work with Alexa:" prop="WwaStatus">
                    <!--el-select v-model="areaForm.WwaStatus" placeholder="请选择" style="width:87%;">
                        <el-option v-for="item in alexaStatus" :key="item.Id" :label="item.Name" :value="item.Name">
                        </el-option>
                    </el-select-->
                    <el-radio-group v-model="areaForm.WwaStatus" >
                        <el-radio label="enable"></el-radio>
                        <el-radio label="disable"></el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="Smart home skill mode:" prop="ShsMode">
                    <!--el-select v-model="areaForm.WwaStatus" placeholder="请选择" style="width:87%;">
                        <el-option v-for="item in alexaStatus" :key="item.Id" :label="item.Name" :value="item.Name">
                        </el-option>
                    </el-select-->
                    <el-radio-group v-model="areaForm.ShsMode" >
                        <el-radio label="legacy"></el-radio>
                        <el-radio label="upgraded"></el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button style="width: 80px;" @click.native="cancelEdit('areaForm')">取消</el-button>
                <el-button style="width: 80px;" type="primary" @click.native="submitEdit('areaForm')" >提交</el-button>
            </div>
        </el-dialog>
    </section>
</template>
<script>
import { Config } from "@/config/config"
import { Country_list, Country_shortName_list } from "@/locale/country_list"
import { addCountry, updateCountry, deleteCountry } from "@/api/country"
import { mapState } from 'vuex'
import Notify from '../../api/notifyMsg'

export default {
    computed: mapState({
        user: state => state.user
    }),
    data() {
        return {
            areaForm: {
                Id: '',
                Country: '',
                Domain: '',
                AvsStatus: '',
                WwaStatus: '',
                ShsMode: '',
                ClientType: ''
            },
            formInline: {
                Keyword: ''
            },
            tableJsonData: [],
            supportedArea: [],
            listLoading: false,
            supportedCountries: '',
            supportClientType: '',
            supportedNa: '',
            gridData: [],
            editFormTitle: "国家详情",
            editType: 0, //0:添加   1：修改
            alexaStatus: [
                { Id: 0, Name: 'enable' },
                { Id: 1, Name: 'disable' }
            ],
            smartHomeSkillMode: [
                { Id: 0, Name: 'legacy' },
                { Id: 1, Name: 'upgraded' }
            ],
            supportDomains : [{ Id: 0, Name: 'AS' }],
            supportCountries : "",
            //areaData: [{Country:"UK", AvsStatus:"enable", WwaStatus:"enable", ClientTypes:["TCL-EU-MS6586-S1", "TCL-EU-MS6586-S3", "TCL-EU-MS6586-S2"]},
            //    {Country:"US", AvsStatus:"enable", WwaStatus:"enable", ClientTypes:["TCL-EU-MS6586-S1", "TCL-EU-MS6586-S3", "TCL-EU-MS6586-S2"]}],
            areaData: [],
            editFormVisible: false,
            editLoading: false,
            pageIndex: 1,
            pageSizes: [10, 20, 30, 40, 50],
            pageSize: 10,
            totaltotal: 0,
            areaApiUrl: "/api/v1/console/country",
            areaFormRules: {
                Country: [{
                    required: true, message: '请输入Country Name',trigger: 'blur'
                }],
                Domain: [{
                    required: true, message: '请输入Domain Name', trigger: 'blur'
                }],
                ClientType: [{
                    required: true, message: '请输入Client Type', trigger: 'blur'
                }],
                AvsStatus: [{
                    required: true, message: '请选择Avs Status', trigger: 'change'
                }],
                WwaStatus: [{
                    required: true, message: '请选择Wwa Status', trigger: 'change'
                }],
                ShsMode: [{
                    required: true, message: '请选择Smart Home Skill Mode', trigger: 'change'
                }],
            },
        };
    },
    methods: {
        seen() {
            if(this.user.Role !== "admin") {
                return false;
            } else {
                return true;
            }
        },
        getData: function () {
            var _this = this;
            _this.areaData = [];
            var offset = (_this.pageIndex-1) * _this.pageSize;
            _this.listLoading = true;
            var keyword = _this.formInline.Keyword;
            console.log("getData keyowrd:", keyword)
            /*_this.$http.get(Config.url+_this.areaApiUrl, {
                params: {
                    keyword: _this.areaForm.Area,
                    offset: offsetStar,
                    limit: _this.pageSize
                }
            })
                .then((response) => {
                    console.log(response.data.Error_code)
                    _this.listLoading = false
                    if (response.data.Error_code === 1000) {
                        if(response.data.area_configs === null) return
                        _this.parseData(response.data);
                    } else {
                        //Notify.errMsgNotify(response.data.Error_code,this)
                        return
                    }
                })
                .catch(function(response) {
                    _this.listLoading = false
                    Notify.catchMsgNotify(this)
                    console.log(response)
                })*/
            fetch(Config.url + _this.areaApiUrl + "?offset=" + offset + "&limit=" + _this.pageSize + "&keyword=" + keyword + "&token=" + _this.user.token)
                .then(response => response.json())
                .then(json => {
                    console.log(json);
                    if (json.Error_code === 1000) {
                        var i;
                        //var j = 0;
                        //var s = new Set();
                        for (i = 0; i < json.area_configs.length; i ++) {
                            var country_id = json.area_configs[i].country_id;
                            var domain = json.area_configs[i].domain;
                            var country = json.area_configs[i].description;
                            var avs_status = json.area_configs[i].avs_status;;
                            var wwa_status = json.area_configs[i].wwa_status;
                            var shs_mode = json.area_configs[i].shs_mode;
                            var client_type = json.area_configs[i].client_type;
                            /*if (json.area_configs[i].client_types !== null && json.area_configs[i].client_types.length > 0) {
                                client_types = json.area_configs[i].client_types.join(";");
                            }
                            /*if (!s.has(domain)) {
                                s.add(domain)
                                _this.$set(_this.supportDomains, j, new _this.domainDetail(i, domain))
                                j++;
                            }*/
                            _this.$set(_this.areaData, i, new _this.showArea(country_id, country, domain, avs_status, wwa_status, shs_mode, client_type));

                        }
                        _this.totaltotal = json.count;
                    } else {
                        Notify.errMsgNotify(json.Error_code, _this)
                        return
                    }
                })
        },
        domainDetail(id, domain) {
            this.Id = id;
            this.Name = domain;
        },
        showArea: function (country_id, country, domain, avs_status, wwa_status, shs_mode, client_type) {
            this.Id = country_id;
            this.Country = country;
            this.Domain = domain;
            this.AvsStatus = avs_status;
            this.WwaStatus = wwa_status;
            this.ShsMode = shs_mode;

            this.ClientType = client_type
        },
        deleteArea: function (row) {
            var _this = this;
            var country = row.Country;
            var client_type = row.ClientType;
            var id = this.getCountryId(country)[0]
            console.log("addArea country:" + country + " id:" +id);
            _this.$confirm('确认删除吗？', '提示', {}).then(() => {
                deleteCountry(id, client_type, _this.user.token)
                    .then(response => {
                        console.log(response)
                        if (response.data.Error_code === 1000) {
                            _this.$message({
                             type: 'success',
                             message: '删除成功！'
                             });
                            _this.areaData = [];
                            _this.getData();
                        } else {
                            /*_this.$message({
                             type: 'fail',
                             message: '删除失败，请重试。'
                             })*/
                            Notify.errMsgNotify(response.data.Error_code, _this)
                        }
                    });
                _this.editFormVisible = false;
            });
        },
        modifyArea: function(form) {
            console.log("modifyArea form:", form);
            var _this = this;
            var country = form.Country;
            var id = this.getCountryId(country)[0];
            //var domain = _this.getName(_this.supportDomains, form.Domain);
            var domain = form.Domain;
            var avs_status = form.AvsStatus;
            var wwa_status = form.WwaStatus;
            var shs_mode = form.ShsMode;
            //var client_types = _this.formatClientType(form.ClientTypes);
            var client_type = form.ClientType;
            console.log("modifyArea country:" + country + " id:" +id + " domain" + domain + " avs:" + avs_status + " wwa:" + wwa_status +" shsMode:" + shs_mode, " clientType:", client_type);
            updateCountry(domain, id.toString(), country, avs_status, wwa_status, shs_mode, client_type, _this.user.token)
                .then(response => {
                    console.log(response)
                    if (response.data.Error_code === 1000) {
                        _this.areaData = [];
                        _this.getData();
                    } else {
                        Notify.errMsgNotify(response.data.Error_code, _this)
                    }
                });
            _this.editFormVisible = false;
        },
        addArea: function (form) {
            console.log("addArea ", form);
            var _this = this;
            //var country = form.Country;
            var result = this.getCountryId(form.Country);
            if(result === undefined || result[0] === undefined || result[1] === undefined) {
                _this.$message({
                    type: 'Fail',
                    message: '不支持的国家！'
                });
                _this.editFormVisible = false;
                return
            }
            var id = result[0];
            var country = result[1];

            var domain = _this.getName(_this.supportDomains, form.Domain);
            var avs_status = form.AvsStatus;
            var wwa_status = form.WwaStatus;
            var shs_mode = form.ShsMode;
            //var client_types = _this.formatClientType(form.ClientTypes);
            var client_type = form.ClientType;
            console.log("addArea country:" + country + " id:" +id + " domain" + domain + " avs:" + avs_status + " wwa:" + wwa_status + "shs mode:"+ shs_mode , " clientType:", client_type);
            addCountry(domain, id.toString(), country, avs_status, wwa_status, shs_mode, client_type, _this.user.token)
                .then(response => {
                    console.log(response)
                    if (response.data.Error_code === 1000) {
                        _this.areaData = [];
                        _this.getData();
                    } else {
                        Notify.errMsgNotify(response.data.Error_code, _this)
                    }
                });
            _this.editFormVisible = false;
        },
        getSupportArea: function () {
            console.log("getSupportArea");
            var _this = this;
            fetch(Config.url + "/api/v1/console/domains?token=" + _this.user.token)
                .then(response => response.json())
                .then(json => {
                    if (json.Error_code === 1000) {
                        var i;
                        for (i = 0; i < json.domains.length; i ++) {
                            var domain = json.domains[i]
                            _this.$set(_this.supportDomains, i, new _this.domainDetail(i, domain))
                        }
                    } else {
                        Notify.errMsgNotify(json.Error_code, _this)
                    }
                });

            fetch(Config.url + "/api/v1/console/supportcountry?domain=EU&token=" + _this.user.token)
                .then(response => response.json())
                .then(json => {
                    var str = json.countries.toString();
                    _this.$set(_this.gridData, _this.gridData.length, new _this.countryDetail("EU", str))
                });

            fetch(Config.url + "/api/v1/console/supportcountry?domain=NA&token=" + _this.user.token)
                .then(response => response.json())
                .then(json => {
                    var str = json.countries.toString();
                    _this.$set(_this.gridData, _this.gridData.length, new _this.countryDetail("NA", str))
                });

            fetch(Config.url + "/api/v1/console/supportcountry?domain=FE&token=" + _this.user.token)
                .then(response => response.json())
                .then(json => {
                    var str = json.countries.toString();
                    _this.$set(_this.gridData, _this.gridData.length, new _this.countryDetail("FE", str))
                })
        },
        formatClientType(str) {
            console.log("formatClientType str:", str)

        },
        countryDetail(area, country) {
            this.area = area;
            this.countries = country;
        },
        queryArea: function () {
            var _this = this;
            _this.getData()
        },
        parseData: function(data) {

        },
        getCountryId: function(country) {
            //console.log("getCountryId", country);
            var _country = country;
            if (_country.length === 2) {
                for (var [key, value] of Country_shortName_list) {
                    //console.log("getCountryId", key, value);
                    if (key.toLowerCase() === _country.toLowerCase()) {
                        console.log("getCountry with shortname shortname:" + _country + " country:" + key);
                        _country = value;
                        break;
                    }
                }
            }

            for (var [key, value] of Country_list) {
                //console.log("getCountryId", key, value);
                if (value.toLowerCase() === _country.toLowerCase()) {
                    console.log("getCountryId country:" + country + " id:" + key);
                    return [key, value]
                }
            }
        },
        getName: function(data, id) {
            console.log("getName", data, id);
            var i;
            for (i = 0; i < data.length; i++) {
                if (data[i].Id === id) {
                    return data[i].Name;
                }
            }
        },
        editArea: function(row, event, column) {
            console.log("EditArea: ", row, row.Country, row.Id, column);
            var _this = this;
            if(column !== undefined && column.property === "Action") {
                return;
            }
            if (!_this.seen()) {
                _this.$message({
                    type: 'fail',
                    message: '没有操作权限！'
                });
                return
            }

            _this.editFormTitle = '修改国家';
            _this.editFormVisible = true;
            _this.editType = 1;

            _this.areaForm.Country = row.Country;
            _this.areaForm.Domain = row.Domain;
            /*_this.areaForm.AreaServer = row.AlexaServer;
            _this.areaForm.AlexaServer = row.AlexaServer;*/
            _this.areaForm.AvsStatus = row.AvsStatus;
            _this.areaForm.WwaStatus = row.WwaStatus;
            _this.areaForm.ShsMode = row.ShsMode;
            _this.areaForm.ClientType = row.ClientType;
        },
        cancelEdit: function(formName) {
            var _this = this;
            _this.editFormVisible = false;
            _this.$refs[formName].resetFields();
            /*_this.areaForm.Country = '';
            _this.areaForm.Domain = '';
            _this.areaForm.AvsStatus = '';
            _this.areaForm.WwaStatus = '';*/
        },
        submitEdit: function(formName) {
            var _this = this;
            if (!_this.seen()) {
                _this.$message({
                    type: 'error',
                    message: '没有操作权限!'
                });
                return
            }

            _this.$refs.areaForm.validate((valid) => {
                if (valid) {
                    _this.$confirm('确认提交吗？', '提示', {}).then(() => {
                        _this.editLoading = true;
                        _this.btnEditText = '提交中';
                        if(_this.editType === 1)
                            _this.modifyArea(_this.areaForm);
                        else
                            _this.addArea(_this.areaForm);
                        setTimeout(function() {
                            _this.editLoading = false;
                            //NProgress.done();
                            _this.btnEditText = '提 交';
                            _this.editFormVisible = false;
                        }, 1000);
                    });
                }
            });
        },
        showAddDialog: function () {
            var _this = this;
            if (!_this.seen()) {
                _this.$message({
                    type: 'fail',
                    message: '没有操作权限！'
                });
                return
            }

            console.log("showAddDialog ", this.editFormVisible)
            _this.editFormTitle = '添加国家';
            _this.editFormVisible = true;
            _this.editType = 0;

            _this.areaForm.Country = '';
            _this.areaForm.Domain = '';
            /*_this.areaForm.AreaServer = '';
            _this.areaForm.AlexaServer = '';*/
            _this.areaForm.AvsStatus = '';
            _this.areaForm.WwaStatus = '';
            _this.areaForm.ShsMode = '';
            _this.areaForm.ClientType = '';
        },
        pageIndexChange: function(pageIndex) {
            var _this = this
            _this.pageIndex = pageIndex
            _this.getData()
        },
        sizeChange: function(pageSize) {
            var _this = this
            _this.pageSize = pageSize
            _this.getData()
        },
    },
    created: function() {
        this.getData();
    },
    mounted: function() {
        this.getSupportArea()
    }
}
</script>
<style scoped>
    .toolbar {
        background: #fff;
        /*padding: 10px 10px 0px 10px;*/
    }

    .dialog_input {
        width: 87%;
    }
</style>


// WEBPACK FOOTER //
// src/components/area/AreaManage.vue